import { EVENT_TYPES } from "~/constants/analytics"

export default (
  events,
  eventCategories,
  localePath,
  accessibleVenueIds,
  venueById,
  i18n
) => events.map(event => {
  const category = eventCategories[event.category]
  const { booking } = event

  let isActiveAvailable = false
  if (event.venue.isActive) {
    const venue = venueById(event.venue.id)
    if (venue) {
      const { activeParentVenue } = venue
      if (activeParentVenue) {
        isActiveAvailable = accessibleVenueIds.includes(activeParentVenue.id)
      }
    }
  }

  const status = booking && booking.processed ? booking.status : event.status

  const guests = booking && booking.numberOfGuests > 0 ? booking.numberOfGuests : null

  return {
    id: event.id,
    category: category && category.name,
    iconUrl: category && category.icon.svg,
    fromDate: event.startsAt,
    opensAt: event.openForBookingAt,
    timezone: event.venue.timeZone,
    description: event.description,
    house: event.digital ? i18n.t('DIGITAL_EVENT') : event.venue.name,
    houseColor: event.venue.colors.dark,
    images: event.images,
    name: event.name,
    isActive: event.venue.isActive && isActiveAvailable,
    status,
    guests,
    to: localePath({ name: 'whats-on-details-id', params: { id: event.id } }),
    digital: event.digital,
    analytics: { id: event.id, type: EVENT_TYPES.event, }
  }
})
